import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable } from '@angular/core';
import type { Logger } from '@core/model/domain/logger';
import { loggerToken } from '@di/angularProviderMapper';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorsHandler implements ErrorHandler {
  constructor(
    private processEventService: ProcessEventService,
    @Inject(loggerToken) private logger: Logger
  ) {}

  /*
    SpawnInternalErrorEvent logic is only triggered when error happened in 
    /process route, other routes have their own error handling
  */
  handleError(error: Error | HttpErrorResponse) {
    this.logger.logException(error);
    this.processEventService.push(
      ProcessEventFactory.SpawnInternalErrorEvent({
        error: error,
        errorOrigin: 'ERROR_HANDLER',
      })
    );
  }
}
